// extracted by mini-css-extract-plugin
export default {"spinner":"W4kve","spinner-blade":"PS3sI","spinner-fade":"LqNKr"};